import { Activity } from "../services/api/user-activity";
import { helpers } from "../utils";

const notificationEventListener = (id) => {
    return Echo.private('users.' + id)
        .notification((notification) => {
            updateNotifications()
            updateCounter()

            $.ajax({
                url: window.location.origin + '/admin/notifications/show/' + notification.id,
                type: 'GET',
                success: function (result) {
                    $('.float-box ul').append(result)

                },
                error: function (result) {
                    new Noty({
                        type: "warning",
                        text: 'Something happened',
                    }).show()
                }
            })

        })
        .listen('WhatsApp\\IncomingMessageEvent', (e) => {
            // console.log(e)
            new Noty({
                theme: 'metroui',
                type: 'alert',
                layout: 'topRight',
                timeout: 5000,
                text: 'New Whatsapp <br> From: ' + e.name
            }).show()
        })
        .listen('TodoCallStatus', (e) => {
            console.log(e)
            //close modal
            var alert = $('.alert-call')
            $('.modal-check-phone').parent().parent().parent().modal('hide')
            var status = e.status
            var button_calling = $('.calling-' + e.todo_id)
            if (status === 'initiated') {
                button_calling.find('span').html('Connecting')
            }
            if (status === 'ringing') {
                button_calling.find('span').html('Ringing')
            }
            if (status === 'in-progress') {
                button_calling.find('span').html('In Call')
            }
            if (status === 'completed') {
                button_calling.find('span').html('Completed')
            }
            if (status === 'canceled') {
                button_calling.hide()
                $('.call-todo').show()
                alert.show().find('.text-alert').html('The call was invalid, you hangup the call before it was being connected <br><b>Please Try Again</b>')
            }
            if (status === 'failed') {
                button_calling.hide()
                $('.call-todo').show()
                alert.show().find('.text-alert').html('The call was invalid, the number you have dialed is invalid <br><b>Please Try Again</b>')
            }
            if (e.reload) {
                ToDo.reload(e.todo_id, e.type, e.type_id)
            }
        })
        .listen('Fireworks', (e) => {
            if (e.level === 'platinum') {
                ion.sound.play('fireworks_sales_platinum');
            } else if (e.level === 'silver' || e.level === 'gold') {
                ion.sound.play('applause');
            } else {
                ion.sound.play('fireworks');
            }

            helpers.eventBus.$emit('show-fireworks', e.level, e.student_name, e.name, e.image, e.message);
        })
        .listen('FireworksVisa', (e) => {
            ion.sound.play("fireworks_visa_approved");
            helpers.eventBus.$emit('show-fireworks-visa', e);
        })
        .listen('IncomingCall', (e) => {
            $('#incoming-call-img').attr("src", e.caller.image)
            $('#incoming-call-name').html(e.caller.name)
            $('.overlay-incoming-call').show()
            ion.sound.play("door_bell")
            //console.log(e)
        })
        .listen('IncomingVideoCall', (e) => {
            $('#incoming-video-call-img').attr("src", e.caller.image)
            $('#incoming-video-call-name').html(e.caller.name)
            $('#incoming-video-call-button').attr('href', e.room)
            $('.overlay-incoming-video-call').show()
            ion.sound.play("incoming_video_call")
        })
        .listen('ScheduledVideoCall', (e) => {
            $('#scheduled-video-call-img').attr("src", e.caller.image)
            $('#scheduled-video-call-name').html(e.caller.name)
            if (e.caller.url) {
                $('#scheduled-video-profile-button').show()
                $('#scheduled-video-profile-button').attr('href', e.caller.url)
            } else {
                $('#scheduled-video-profile-button').hide()
            }

            $('#scheduled-video-call-button').attr('href', e.room)
            $('.overlay-scheduled-video-call').show()
            if (e.has_participant) {
                $('#scheduled-video-has-participant').show()
            } else {
                $('#scheduled-video-has-participant').hide()
            }
            ion.sound.play("incoming_video_call")
        })
        .listen('UniPhone', (e) => {
            if (e.status === 'offline' && e.by_pass === "0") {
                $('.overlay-uni-phone').show()
            } else {
                $('.overlay-uni-phone').hide()
            }
        })
        .listen('CheckUserStatus', (e) => {
            helpers.eventBus.$emit('show-check-status-overlay');
        })
        .listen('HideOverlay', (e) => {
            $('.' + e.name).hide()
            $('#confetti-animation').remove();
        })
        .listen('UserKickOut', async () => {
            try {
                await Activity.changeStatus('offline');
                await axios.get('/admin/logout');
                location.reload();
            } catch (error) {
                console.error("Error occurred during logout:", error);
            }
        })

        .error((error) => {
            console.error("Error details:", error);
            console.error("Echo error at channel users."+id);
        })
}

export { notificationEventListener }